// Version : 0.0.1
// Author : VAIBAV
// MODIFIED DATA : 23-12-2025

import CollectionFormatReportTypes from './collection-format-report.types';

/* ********************FETCH CollectionFormat DETAILS START *********************** */
export const fetchCollectionFormatReportStart = (addData: any) => ({
	type: CollectionFormatReportTypes.FETCH_COLLECTION_FORMAT_REPORT_START,
	payload: addData,
});

export const fetchCollectionFormatReportSuccess = (successData: any) => ({
	type: CollectionFormatReportTypes.FETCH_COLLECTION_FORMAT_REPORT_SUCCESS,
	payload: successData,
});

export const fetchCollectionFormatReportFailure = (failureData: any) => ({
	type: CollectionFormatReportTypes.FETCH_COLLECTION_FORMAT_REPORT_FAILURE,
	payload: failureData,
});

export const fetchCollectionFormatReportResponseResetStart = () => ({
	type: CollectionFormatReportTypes.FETCH_COLLECTION_FORMAT_REPORT_RESPONSE_RESET_START,
});

export const fetchCollectionFormatReportResponseResetChanged = () => ({
	type: CollectionFormatReportTypes.FETCH_COLLECTION_FORMAT_REPORT_RESPONSE_CHANGED,
});

/* ***********************FETCH CollectionFormat DETAILS END ********************* */
